import React, { useState } from "react";

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "What is income funnel optimization?",
      answer: "Sales funnel optimization is the method of improving each level of your funnel to transform extra visitors into leads and clients. It helps boom conversions and maximize sales.",
    },
    {
      question: "Why is income funnel optimization crucial?",
      answer: "It enables reduce drop-offs, improve user revel in, and boom your conversion rate, ensuring you get higher outcomes out of your current site visitors.",
    },
    {
      question: "What are the degrees of a income funnel?",
      answer: "The fundamental ranges are Awareness, Interest, Decision, and Action. Each degree desires right optimization to manual users towards conversion.",
    },
    {
      question: "How lengthy does it take to look effects?",
      answer: "Initial enhancements may be visible within a few weeks, but regular optimization provides lengthy-time period growth and better ROI.",
    },
    {
      question: "What gear are utilized in funnel optimization?",
      answer: "Common tools encompass analytics tools, heatmaps, A/B trying out equipment, CRM structures, and advertising automation platforms.",
    },

  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="k-faq-section">
      <div className="k-faq-container">
        <h2 className="k-faq-heading">Frequently Asked Questions</h2>

        {faqData.map((item, index) => (
          <div
            key={index}
            className={
              activeIndex === index ? "k-faq-box active" : "k-faq-box"
            }
          >
            <div
              className="k-faq-question"
              onClick={() => toggleFAQ(index)}
            >
              <span className="k-faq-title">{item.question}</span>
              <span className="k-faq-arrow">
                {activeIndex === index ? "▲" : "▼"}
              </span>
            </div>

            <div className="k-faq-answer">
              <p className="k-faq-text">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;